import React, {
	//useState,
	useEffect,
	//useMemo,
	//useCallback,
} from 'react';
//import logo from 'logo.svg';
import './App.css';
import { Home } from 'pages/home.js';
import {
	BrowserRouter,
	//HashRouter as Router,
	Switch,
	Route,
	//Link,
	//useRouteMatch,
	//useParams
} from "react-router-dom";

import { PrivacyPolicy } from 'pages/privacyPolicy';
// import { AnimalsByDay } from 'pages/animalsByDay/animalsByDay';

import { WeightChart } from 'pages/weightChart/weightChart.js';

//import { DistributionByWeek } from 'pages/distributionByWeek/distributionByWeek.js';
import { WeightDistribution } from 'pages/weightDistribution/weightDistribution.js';

//import SessionData from 'pages/sessionData/sessionData.js';
import { SessionData2 } from 'pages/sessionData2/sessionData2.js';

import { SessionManagement } from 'pages/sessionManagement/sessionManagement.js';
import { LongTermData } from 'pages/longTermData/longTermData.js';
//import { YardWeightData } from 'pages/yardWeightData/yardWeightData.js';
//import { YardWeightChart } from 'pages/yardWeightChart/yardWeightChart.js';
import { Callback } from 'pages/auth/callback.js';
import { Signout } from 'pages/auth/signout.js';
import { Staff } from 'pages/staff/staff.js';
import { DbsysLog } from 'pagesStaff/dbsysLog/dbsysLog.js'
import { DailyEmail } from 'pagesStaff/dailyEmail/dailyEmail.js'
import { YardWeights } from 'pagesStaff/yardWeights.js';
import useGTM from '@elgorditosalsero/react-gtm-hook';


/**
 * IMPORTANT - need to do this to get react router working on the Cloudfront server
 *
 * SPAs which redirect to URL paths but still want to be handled by the root path
 *
 * refer: https://johnlouros.com/blog/using-CloudFront-to-serve-an-SPA-from-S3
 *
 * in cloudfront distribution
 * create custom error responses:
 *
 * http code: 403
 * ttl: 300
 * custom error response: YES
 * response p[ath: index.html
 * reponse code 200 OK
 *
 * http code: 404
 * ttl: 300
 * custom error response: YES
 * response path: index.html
 * reponse code 200 OK
 *

 */
function App() {

	const { init, UseGTMHookProvider } = useGTM()
	//	https://github.com/elgorditosalsero/react-gtm-hook

	useEffect(() => {
		const gtmParams = {
			id: process.env.REACT_APP_GTM_ID,
			//dataLayerName: 'client-portal'
			//id: 'GTM-5NXHX7C',
			// environment: {
			//   gtm_auth: 'my-auth-token',
			//   gtm_preview: 'preview-id'
			// }
		}
		init(gtmParams);
	}, [init])

	return (
		<UseGTMHookProvider>
		<BrowserRouter>
			<div>
				{/* <ul>
					<li><Link to="/">Home</Link></li>
				</ul> */}

				<Switch>
					<Route path="/auth/callback" component = { Callback } />
					<Route path="/auth/signout" component = { Signout } />
					{/* <Route path="/report/animalsByDay" component = { AnimalsByDay } /> */}
					<Route path="/report/weightChart" component = { WeightChart } />

					{/* <Route path="/report/distributionByWeek" component = { DistributionByWeek } /> */}
					<Route path="/report/weightDistribution" component = { WeightDistribution } />

					<Route path="/report/sessionData2" component = { SessionData2 } />
					<Route path="/report/longTermData" component = { LongTermData } />
					<Route path="/manage/session" component = { SessionManagement } />

					<Route path="/staff/dbsysLog" component = { DbsysLog } />
					<Route path="/staff/dailyEmail" component = { DailyEmail } />
					<Route path="/staff/yardWeights" component = { YardWeights } />
					<Route path="/staff" component = { Staff } />

					<Route path="/privacy" component = { PrivacyPolicy } />
					{/* <Route path="/"><Home /></Route> */}
					<Route path="/" component = { Home } />
				</Switch>
			</div>
		</BrowserRouter>
		</UseGTMHookProvider>
	);
}
// http://localhost:3000/privacy
export default App;
